import React, { useState } from "react";
import styles from "./PremierGallerySection.module.scss";
import Title from "components/title/Title";
import ArtistCard from "components/cards/artistCard/ArtistCard";

const PremierGallerySection = () => {
  const [selectedTab, setSelectedTab] = useState("painters");

  return (
    <div className={styles.premierGallerySectionContainer}>
      <div className="container">
        <Title text={"Premier Gallery"} bottomStrokeWidth={"62%"} />
        <div className={styles.dateWithTabs}>
          <div className={styles.tabs}>
            <div className={styles.tabHeader}>
              <div className={styles.firstTab}>March - April 2025</div>
              <div
                className={`${styles.tab} ${
                  selectedTab === "painters" ? styles.active : ""
                }`}
                onClick={() => setSelectedTab("painters")}
              >
                Painters
              </div>
              <div
                className={`${styles.tab} ${
                  selectedTab === "sculptors" ? styles.active : ""
                }`}
                onClick={() => setSelectedTab("sculptors")}
              >
                Sculptors
              </div>
            </div>
            <div className={styles.tabContent}>
              {selectedTab === "painters" ? (
                <div className={styles.artistCardContainer}>
                  <ArtistCard type={"painter"} showArtworks={true} />
                  <ArtistCard type={"painter"} showArtworks={true} />
                  <ArtistCard type={"painter"} showArtworks={true} />
                  <ArtistCard type={"painter"} showArtworks={true} />
                  <ArtistCard type={"painter"} showArtworks={true} />
                  <ArtistCard type={"painter"} showArtworks={true} />
                </div>
              ) : null}
              {selectedTab === "sculptors" ? (
                <div className={styles.artistCardContainer}>
                  <ArtistCard type={"sculptor"} showArtworks={true} />
                  <ArtistCard type={"sculptor"} showArtworks={true} />
                  <ArtistCard type={"sculptor"} showArtworks={true} />
                  <ArtistCard type={"sculptor"} showArtworks={true} />
                  <ArtistCard type={"sculptor"} showArtworks={true} />
                  <ArtistCard type={"sculptor"} showArtworks={true} />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PremierGallerySection;
